module.exports = __webpack_public_path__ + "img/IT0001286988757.e65188a6.png";